export default __webpack_public_path__ + "static/media/ic_clock.388b9f6a.svg";